// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file sales/void_sale.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";

/**
 * @generated from message com.neulink.pharmacy.VoidSaleRequest
 */
export class VoidSaleRequest extends Message<VoidSaleRequest> {
  /**
   * Unique identifier for the sale to be voided
   *
   * @generated from field: string sale_id = 1;
   */
  saleId = "";

  /**
   * Reason for voiding the sale
   *
   * @generated from field: string reason = 2;
   */
  reason = "";

  constructor(data?: PartialMessage<VoidSaleRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.VoidSaleRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "sale_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): VoidSaleRequest {
    return new VoidSaleRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): VoidSaleRequest {
    return new VoidSaleRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): VoidSaleRequest {
    return new VoidSaleRequest().fromJsonString(jsonString, options);
  }

  static equals(a: VoidSaleRequest | PlainMessage<VoidSaleRequest> | undefined, b: VoidSaleRequest | PlainMessage<VoidSaleRequest> | undefined): boolean {
    return proto3.util.equals(VoidSaleRequest, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.VoidSaleResponse
 */
export class VoidSaleResponse extends Message<VoidSaleResponse> {
  constructor(data?: PartialMessage<VoidSaleResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.VoidSaleResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): VoidSaleResponse {
    return new VoidSaleResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): VoidSaleResponse {
    return new VoidSaleResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): VoidSaleResponse {
    return new VoidSaleResponse().fromJsonString(jsonString, options);
  }

  static equals(a: VoidSaleResponse | PlainMessage<VoidSaleResponse> | undefined, b: VoidSaleResponse | PlainMessage<VoidSaleResponse> | undefined): boolean {
    return proto3.util.equals(VoidSaleResponse, a, b);
  }
}

